import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import AuthMenu from "./AuthMenu";

export default function MenuNav() {
  const location = useLocation();

  const closeOffcanvas = () => {
    const backdrop = document.querySelector(".offcanvas-backdrop");
    const body = document.body;
    const offcanvas = document.querySelector(".offcanvas.show");

    if (backdrop) backdrop.remove();
    if (body.classList.contains("offcanvas-backdrop")) {
      body.classList.remove("offcanvas-backdrop");
    }
    if (body.classList.contains("modal-open")) {
      body.classList.remove("modal-open");
    }
    if (offcanvas) {
      offcanvas.classList.remove("show");
    }
    body.style.overflow = "";
  };

  const matchPath = (path) =>
    location.pathname === path || location.pathname.startsWith(path);

  const getNavClass = (active) =>
    `menu-link btn btn-sm fw-semibold rounded-pill px-3 ${
      active ? "menu-link-active" : "menu-link-inactive"
    }`;

  return (
    <>
      <style>{`
        .menu-nav-wrapper {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
          border-bottom: 1px solid rgba(0,0,0,0.06);
          box-shadow: 0 8px 24px rgba(0,0,0,0.05);
        }

        .menu-brand {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          text-decoration: none;
        }

        .menu-brand img {
          transition: transform 0.3s ease;
        }

        .menu-brand:hover img {
          transform: scale(1.03);
        }

        .menu-link {
          transition: all 0.25s ease;
          border: 1px solid transparent;
          white-space: nowrap;
        }

        .menu-link-inactive {
          background: transparent;
          color: #1f2937;
        }

        .menu-link-inactive:hover {
          background: rgba(12, 30, 71, 0.06);
          color: #0C1E47;
          border-color: rgba(12, 30, 71, 0.08);
          transform: translateY(-1px);
        }

        .menu-link-active {
          background: linear-gradient(135deg, #0C1E47 0%, #16356f 100%);
          color: #fff !important;
          box-shadow: 0 8px 18px rgba(12, 30, 71, 0.18);
        }

        .menu-link-contact {
          background: linear-gradient(135deg, #F7931E 0%, #ff9f2f 100%);
          color: #fff !important;
          border: none;
          box-shadow: 0 8px 18px rgba(247, 147, 30, 0.22);
        }

        .menu-link-contact:hover {
          transform: translateY(-1px);
          opacity: 0.96;
        }

        .menu-desktop-nav {
          background: rgba(248, 250, 252, 0.9);
          border: 1px solid rgba(0,0,0,0.05);
          border-radius: 999px;
          padding: 8px;
        }

        .menu-right-zone {
          gap: 12px;
        }

        .burger-btn {
          width: 46px;
          height: 46px;
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }

        @media (max-width: 767.98px) {
          .menu-nav-inner {
            padding-top: 4px;
            padding-bottom: 4px;
          }

          .menu-brand img {
            width: 88px;
          }
        }
      `}</style>

      <header className="menu-nav-wrapper sticky-top px-3 px-lg-4 py-2">
        <div className="d-flex justify-content-between align-items-center menu-nav-inner">
          {/* Logo */}
          <NavLink to="/" className="menu-brand" onClick={closeOffcanvas}>
            <img
              src="/logo192.png"
              alt="Logo THE BRIDGE"
              width="100"
              height="auto"
              loading="lazy"
            />
          </NavLink>

          {/* Zone droite */}
          <div className="d-flex align-items-center ms-auto menu-right-zone">
            {/* Navigation desktop */}
            <nav className="d-none d-md-flex align-items-center gap-2 menu-desktop-nav">
              <NavLink
                to="/"
                className={getNavClass(matchPath("/"))}
                onClick={closeOffcanvas}
              >
                Accueil
              </NavLink>

              <NavLink
                to="/catalogue"
                className={getNavClass(
                  matchPath("/catalogue") ||
                    matchPath("/marques") ||
                    matchPath("/vehicules")
                )}
                onClick={closeOffcanvas}
              >
                Nos véhicules
              </NavLink>

              <NavLink
                to="/locations"
                className={getNavClass(
                  matchPath("/locations") || matchPath("/reservation")
                )}
                onClick={closeOffcanvas}
              >
                Location
              </NavLink>

              <NavLink
                to="/pieces-detachees"
                className={getNavClass(
                  matchPath("/pieces-detachees") || matchPath("/piece")
                )}
                onClick={closeOffcanvas}
              >
                Pièces détachées
              </NavLink>

              <NavLink
                to="/a-propos"
                className={getNavClass(matchPath("/a-propos"))}
                onClick={closeOffcanvas}
              >
                À propos
              </NavLink>

              <NavLink
                to="/contact"
                className={`btn btn-sm fw-semibold rounded-pill px-3 menu-link-contact ${
                  matchPath("/contact") ? "opacity-100" : ""
                }`}
                onClick={closeOffcanvas}
              >
                Contact
              </NavLink>
            </nav>

            {/* Auth + burger */}
            <div className="d-flex align-items-center gap-2">
              <AuthMenu />

              <button
                className="btn btn-outline-dark d-md-none burger-btn"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#mobileMenu"
                aria-controls="mobileMenu"
                aria-label="Ouvrir le menu"
              >
                <i className="bi bi-list fs-4"></i>
              </button>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
